/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Feature_Team_Model_SettingsInputs */



/**
* | output |
* | --- |
* | "Model settings (admin)" |
*
* @param {Plan_Feature_Team_Model_SettingsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_feature_team_model_settings = /** @type {((inputs?: Plan_Feature_Team_Model_SettingsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Feature_Team_Model_SettingsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Modelleinstellungen (Admin)")
	return /** @type {LocalizedString} */ ("Model settings (admin)")
});